import React from 'react'
import { SimpleTabs } from '@/components/lib'

import useStore from '../../../store'
import useTitle from '../../../hooks/useTitle'
import Stages from './Stages'
import StageGroups from './StageGroups'
import Anchors from './Anchors'
import FoodDiaries from './FoodDiaries'

export default function StagesIndex () {
  const { trial } = useStore()
  useTitle('Stages', trial)
  return (
    <SimpleTabs
      tabs={[
        { title: 'Stages', content: <Stages /> },
        { title: 'Stage groups', content: <StageGroups /> },
        { title: 'Anchors', content: <Anchors /> },
        { title: 'Food diaries', content: <FoodDiaries /> }
      ]}
    />
  )
}
